import * as types from '../mutation-types'

const app = {
  state: {
    loading: false,
    loadMenu: false,
    contentLoading: true,
    language: 'en-US',
    menusArr: [],
    currentMenus: [],
    initData: {},
    showMenus: true,
    domain: '',
    token: ''
  },

  getters: {
    getLoading: state => state.loading,
    getLoadMenu: state => state.loadMenu,
    getContentLoading: state => state.contentLoading,
    getLanguage: state => state.language,
    getMenusArr: state => state.menusArr,
    getCurrentMenus: state => state.currentMenus,
    getInitData: state => state.initData,
    getShowMenus: state => state.showMenus,
    getDomain: state => state.domain,
    getToken: state => state.token
  },

  mutations: {
    [types.PAGE_LOADING](state, info) {
      state.loading = info
    },
    [types.MENU_LOADING](state, info) {
      state.loadMenu = info
    },
    [types.UPDATE_CONTENT_LOADING](state, info) {
      state.contentLoading = info
    },
    [types.UPDATE_LANGUAGE](state, info) {
      state.language = info
    },
    [types.UPDATE_MENUSARR](state, info) {
      state.menusArr = info
    },
    [types.UPDATE_CURRENT_MENUS](state, info) {
      state.currentMenus = info
    },
    [types.UPDATE_INIT_DATA](state, info) {
      state.initData = info
    },
    [types.UPDATE_SHOW_MENUS](state, info) {
      state.showMenus = info
    },
    [types.UPDATE_DOMAIN](state, info) {
      state.domain = info
    },
    [types.UPDATE_TOKEN](state, info) {
      state.token = info
    }
  },

  actions: {
    //将权限控制置为false
    updateLoading({ commit }, info) {
      commit(types.PAGE_LOADING, info)
    },
    //将获取菜单设置
    updateLoadMenu({ commit }, info) {
      commit(types.MENU_LOADING, info)
    },
    updateContentLoad({ commit }, info) {
      commit(types.UPDATE_CONTENT_LOADING, info)
    },
    updateLanguage({ commit }, info) {
      commit(types.UPDATE_LANGUAGE, info)
    },
    updateMenusArr({ commit }, info) {
      commit(types.UPDATE_MENUSARR, info)
    },
    updateCurrentMenus({ commit }, info) {
      commit(types.UPDATE_CURRENT_MENUS, info)
    },
    updateInitData({ commit }, info) {
      commit(types.UPDATE_INIT_DATA, info)
    },
    updateShowMenus({ commit }, info) {
      commit(types.UPDATE_SHOW_MENUS, info)
    },
    updateDomain({ commit }, info) {
      commit(types.UPDATE_DOMAIN, info)
    },
    updateToken({ commit }, info) {
      commit(types.UPDATE_TOKEN, info)
    }
  }
}

export default app
